import React from 'react';
import '../../App.css';

export default function About() {
	return (
		<div>
			<h1 className='about'>About Lift Bro</h1>
			<p className='about-description'>Lift Bro generates personalized workout plans based on your goals. Whether you're looking to build muscle, lose weight, or improve your fitness, we'll create a plan tailored specifically to you.</p>
		</div>
	);
}
